module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.copy')))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.$t('pos.pixel.last-fired', {
    when: _vm.pixelFiredTimeText
  })) + ")")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1479f7c6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facebook-pixel/FacebookPixel.vue
// module id = 2007
// module chunks = 1